import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}

// Remove any injected third-party badges
const removeBadge = () => {
  const badge = document.getElementById('emergent-badge');
  if (badge) badge.remove();
};
removeBadge();
const badgeObserver = new MutationObserver(removeBadge);
badgeObserver.observe(document.body, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
